export default "__VITE_ASSET__BOxw4BiY__"